import { render, staticRenderFns } from "./ApprovalPending.vue?vue&type=template&id=5600c0dc&scoped=true"
import script from "./ApprovalPending.vue?vue&type=script&lang=ts"
export * from "./ApprovalPending.vue?vue&type=script&lang=ts"
import style0 from "./ApprovalPending.vue?vue&type=style&index=0&id=5600c0dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5600c0dc",
  null
  
)

export default component.exports